export const cardErrorMessages = {
  "Blocked Card":
    "Your card is blocked. Get in touch with your bank to find out more.",
  "CVC Declined": "The specified CVC (card security code) is invalid.",
  "Expired Card": "Your card has expired.",
  "Invalid Card Number":
    "The specified card number is incorrect or invalid. If your details are correct, get in touch with your bank to find out more.",
  Refused:
    "Your card was declined. If your details are correct, get in touch with your bank to find out more.",
  "Not enough balance":
    "Your card does not have enough balance to cover the payable amount.",
  "3D Not Authenticated":
    "Your payment authentication has failed. Please try again or get in touch with your bank if your authentication details are correct.",
};

export const cardErrorDefaultMessage =
  "There was a problem processing your card. Check the details entered.";
